import React from 'react';
import styled from 'styled-components';
import { toPounds } from './../../services/Formats';

export const NoData = () => (
  <div style={{
    textAlign: 'center',
    fontFamily: 'Ubuntu,arial', fontSize: 64, fontWeight: 'bold',
    color: '#000',
    opacity: 0.3,
    paddingTop: 120
  }}>NO DATA</div>
)


const Label = styled.div`
  font-family: 'Ubuntu',arial;
  font-size: 16px;
  font-weight: 100;
  padding: 10px;
  color: #888;
  .value { color: ${props => props.color }}
`;

const WhiteCentered = styled.div`
  flex: 1;
  text-align: center;
  color: white;
  font-family: 'Ubuntu',arial;
  font-size: 14px;
  font-weight: 600;
`;

export const TheHouse = ({ contentHeight, color, styling, max, price, protectedAmount }) => {
  const realHeight = contentHeight; // 440 - (348 + 17);
  const dy = realHeight / max;

  const hValue = price * dy - 20;
  const hProtected = protectedAmount * dy + 5;
  const image_prefix = `images/${styling}house`;

  const pct = Math.round(100 * protectedAmount / price);
  return (
    <div style={{ background: '#e6eaf1', borderRadius: 5, height: realHeight + 3, marginTop: 20 }}>
      <div style={{ height: max * dy - hValue }}></div>
      <div style={{ display: 'flex', position: 'relative', borderTop: `3px ${color} dotted` }}>

        <div style={{ position: 'absolute', zIndex: 100, left: 0, width: '100%', top: hValue - hProtected,
          borderTop: `3px ${color} dotted` }}></div>

        <div style={{
          position: 'absolute', zIndex: 101, left: 0, width: '100%',
          top: - 50
        }}>
          <Label color={color}>
            Property Value<br /><strong className="value">{toPounds(price)}</strong>
          </Label>
        </div>

        <div style={{
          position: 'absolute', zIndex: 101, left: 0, width: '100%',
          top: hValue - hProtected
        }}>
          <Label color={color}>
              Equity Protected<br /><strong className="value">{toPounds(protectedAmount)}</strong>
          </Label>
        </div>

        <div style={{ width: 130 }}>
          <div style={{ overflow: 'hidden', height: hValue, display: 'flex'}}>
          </div>
        </div>


          <div style={{
            position: 'relative', flex: 1, height: hValue,
            width: '100%',
            background: `url(${image_prefix}_bk1.png) no-repeat`,
            backgroundSize: '100%',
            backgroundPosition: 'center bottom', overflow: 'hidden'
          }}>

          <div style={{
            position: 'absolute',
            left: 0, width: '100%',
            top: hValue - hProtected,
            height: hProtected,
            display: 'flex',
            color: 'white',
            alignItems: 'center'
          }}>
            <WhiteCentered>{pct}%<br />protected</WhiteCentered>
          </div>

          <div style={{
            height: hValue-hProtected,
            width: '100%',
            background: `url(${image_prefix}_bk0.png) repeat-y`,
            backgroundSize: '100%',
            backgroundPosition: 'center bottom', overflow: 'hidden'
          }}>
          </div>

          <div style={{
            position: 'absolute',
            zIndex: 99,
            left: 0,
            width: '100%',
            top: 0
          }}>
            <img src={`${image_prefix}_roof.png`} alt='' style={{ width: '100%' }} />
          </div>


        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/GuaranteedInheritance/TheHouse.js